var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "catalog-menu" } },
    [
      !_vm.isEditMenu
        ? _c("div", { staticClass: "caption" }, [
            _c(
              "div",
              {
                staticClass: "title",
                on: {
                  click: function ($event) {
                    return _vm.navigateTo(_vm.data)
                  },
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.data.languageContent[_vm.$i18n.locale].name) +
                    "\n            "
                ),
                _c(
                  "md-button",
                  [_c("md-icon", [_vm._v("arrow_forward_ios")])],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "actions" },
              [
                _vm.data.type === "menu"
                  ? _c(
                      "md-button",
                      {
                        staticClass: "trash",
                        on: {
                          click: function ($event) {
                            _vm.isEditMenu = true
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("edit")])],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "md-button",
                  {
                    staticClass: "trash",
                    on: {
                      click: function ($event) {
                        return _vm.deleteCatalog(_vm.data._id)
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("delete")])],
                  1
                ),
              ],
              1
            ),
          ])
        : _c(
            "b-tabs",
            _vm._l(_vm.languages, function (lang, i) {
              return _c("b-tab", { key: i, attrs: { title: lang.name } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.catalogForm.languageContent[lang.code].name,
                      expression: "catalogForm.languageContent[lang.code].name",
                    },
                  ],
                  staticClass: "inputTitle",
                  attrs: { autofocus: "", type: "text" },
                  domProps: {
                    value: _vm.catalogForm.languageContent[lang.code].name,
                  },
                  on: {
                    keydown: _vm.handleKeyDown,
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.catalogForm.languageContent[lang.code],
                        "name",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "actionsButtonCancel",
                    on: {
                      click: function ($event) {
                        _vm.isEditMenu = false
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.cancel")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "actionsButton",
                    on: { click: _vm.updatedMenu },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("message.update")) +
                        "\n            "
                    ),
                  ]
                ),
              ])
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }